import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './DiscountHead.module.less';
import { getDiscountRankMenu, handleTpye, handleOrder } from '../../../actions/discount';
import { logging, logPostInfo } from '../../../actions/log';

const selectRankMenu = createSelector(
  state => state.discount,
  discount => discount.rankAppMenu,
);

const selectRankType = createSelector(
  state => state.discount,
  discount => discount.selectType,
);

const selectRankOrder = createSelector(
  state => state.discount,
  discount => discount.selectOrder,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const menu = useSelector(selectRankMenu);
  const rankType = useSelector(selectRankType);
  const rankOrder = useSelector(selectRankOrder);
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    if (rankType === null && rankOrder === null) {
      menu?.typeParams?.forEach(item => {
        if (item.selected) {
          dispatch(handleTpye(item.code));
        }
      });
      menu?.orderParams?.forEach(item => {
        if (item.selected) {
          dispatch(handleOrder(item.code));
        }
      });
    }
  }, [rankType, rankOrder, menu]);

  const handleLeftTabId = code => {
    dispatch(
      logging({
        category: 'C',
        action: 'Sales_Rank_Type',
        label: '',
        param2: {
          type: code,
          source: 'Sales_Rank',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(handleTpye(code));
  };

  const handleRightTabId = code => {
    dispatch(
      logging({
        category: 'C',
        action: 'Sales_Rank_Sort',
        label: '',
        param2: {
          type: code,
          source: 'Sales_Rank',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(handleOrder(code));
  };

  return (
    <div className={styles.discount_head}>
      <div className="rank_tab_left">
        {menu?.typeParams?.map((item, index) => (
          <div
            key={index}
            className={`rank_tab_left_item ${
              rankType === item.code || (rankType === null && item.selected)
                ? 'rank_tab_item_active'
                : ''
            }`}
            onClick={() => {
              handleLeftTabId(item.code);
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
      <div className="rank_tab_right">
        {menu?.orderParams?.map((item, index) => (
          <div
            key={index}
            className={`rank_tab_right_item  ${
              rankOrder === item.code || (rankOrder === null && item.selected)
                ? 'rank_tab_right_item_active'
                : ''
            } `}
            onClick={() => {
              handleRightTabId(item.code);
            }}
          >
            {item.name}
          </div>
        ))}
      </div>
    </div>
  );
});
